import React from "react";
import { IReactSelectOption } from "../models/ReactSelect.models";
import Select from "react-select/creatable";

interface Props {
  label?: string;
  placeholder?: string;
  loading: boolean;
  loadingOptions: boolean;
  onCreateOption?: (value: string) => void;
}

const customStyles = {
  control: base => ({
    ...base,
    height: 40,
    minHeight: 40,
  }),
};

export const EmptyFormikMultiselect = React.memo(
  ({ label, loading, loadingOptions, placeholder, onCreateOption }: Props) => {
    return (
      <div>
        {label && (
          <label htmlFor="choices-multiple-default" className="form-label ">
            {label}
          </label>
        )}
        <Select
          id={"fieldName"}
          name={"fieldName"}
          isMulti
          options={[]}
          placeholder={`Seleccionar ${label || placeholder}..`}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(event: IReactSelectOption[]) => {}}
          styles={customStyles}
          isDisabled={loading || loadingOptions}
          isLoading={loading || loadingOptions}
          formatCreateLabel={(value: string) => {
            return `Agregar "${value}"`;
          }}
          onCreateOption={onCreateOption}
        />
      </div>
    );
  }
);
